import "core-js/stable";
import "regenerator-runtime/runtime";
import "wicg-inert";
import "lazysizes";

import { on } from "delegated-events";
import { define } from "wicked-elements";

import "./lib/header";
import "./lib/slider";

on("click", "[data-toggle-all-work]", toggleWork);

define("a[href]", {
  init() {
    if (this.element.hostname !== location.hostname) {
      this.element.rel = "noopener";
      this.element.target = "_blank";
    }
  },
});

/**
 * @param {Event} event
 * @returns
 */
function toggleWork(event) {
  event.preventDefault();
  /** @type {HTMLElement} */
  const allWork = document.querySelector(".work-archive");
  if (!allWork) return;
  const isHidden = allWork.hidden;
  allWork.hidden = !isHidden;
  allWork.inert = !isHidden;
}

window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty(
    "--scroll-y",
    `${window.scrollY}px`
  );
});

const ProjectCover = {
  ontouchstart() {
    document
      .querySelectorAll(".project-cover")
      .forEach((element) => element.classList.remove("active"));
    this.element.classList.add("active");
  },
};

define(".project-cover", ProjectCover);
